import { Box, HStack } from 'styled-system/jsx';

import { useFromInput } from '../../hooks/useFromInput';
import { CollateralInputSection } from './CollateralInputSection';
import { useOrderType } from './store/useOrderType';
import { TPSLInput } from './TPSLInput';
import { TriggerPriceInput } from './TriggerPriceInput';

export const Inputs = () => {
  const input = useFromInput((s) => s.input);
  const setInput = useFromInput((s) => s.setInput);
  const orderType = useOrderType((s) => s._persistValue);

  return (
    <Box>
      <TriggerPriceInput
        orderType={orderType}
        value={input.triggerPrice ?? ''}
        onInput={(_input) => {
          setInput({
            ...input,
            triggerPrice: _input,
          });
        }}
      />
      <HStack mt="11px" w="full" gap="8px">
        <CollateralInputSection />
      </HStack>
      <TPSLInput mt="11px" />
    </Box>
  );
};
